// Interface to load env variables
// Note these variables can possibly be undefined
// as someone could skip these varibales or not setup a .env file at all

interface ENV {
  NODE_ENV: string | undefined;
  REACT_APP_ALGOLIA_SITE_INDEX: string | undefined;
  REACT_APP_ALGOLIA_Integration_INDEX: string | undefined;
  REACT_APP_ALGOLIA_RESOURCES_INDEX: string | undefined;
  // REACT_APP_ALGOLIA_EVENTS_INDEX: string | undefined;
  // REACT_APP_ALGOLIA_COURSES_INDEX: string | undefined; 
  REACT_APP_ALGOLIA_PRESS_INDEX: string | undefined; 
  REACT_APP_ALGOLIA_BLOGS_INDEX: string | undefined;
  REACT_APP_ALGOLIA_APP_ID:  string | undefined;
  REACT_APP_ALGOLIA_API_KEY:   string | undefined;
}

interface Config {
  NODE_ENV: string;
  REACT_APP_ALGOLIA_SITE_INDEX: string;
  REACT_APP_ALGOLIA_Integration_INDEX: string;
  REACT_APP_ALGOLIA_RESOURCES_INDEX: string;
  // REACT_APP_ALGOLIA_EVENTS_INDEX: string;
  // REACT_APP_ALGOLIA_COURSES_INDEX: string;
  REACT_APP_ALGOLIA_PRESS_INDEX: string;
  REACT_APP_ALGOLIA_BLOGS_INDEX: string;
  REACT_APP_ALGOLIA_APP_ID: string;
  REACT_APP_ALGOLIA_API_KEY: string;
}

// Loading process.env as ENV interface

const getConfig = (): ENV => {
  return {
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_ALGOLIA_SITE_INDEX: process.env.REACT_APP_ALGOLIA_SITE_INDEX ? String(process.env.REACT_APP_ALGOLIA_SITE_INDEX) : 'wp_posts_page',
    REACT_APP_ALGOLIA_Integration_INDEX: process.env.REACT_APP_ALGOLIA_Integration_INDEX ? String(process.env.REACT_APP_ALGOLIA_Integration_INDEX) : 'wp_posts_type-integrations',   
    REACT_APP_ALGOLIA_RESOURCES_INDEX: process.env.REACT_APP_ALGOLIA_RESOURCES_INDEX ? String(process.env.REACT_APP_ALGOLIA_RESOURCES_INDEX) : 'wp_posts_type-resources',
    // REACT_APP_ALGOLIA_EVENTS_INDEX: process.env.REACT_APP_ALGOLIA_EVENTS_INDEX ? String(process.env.REACT_APP_ALGOLIA_EVENTS_INDEX) : 'wp_posts_tribe_events',
    // REACT_APP_ALGOLIA_COURSES_INDEX: process.env.REACT_APP_ALGOLIA_COURSES_INDEX ? String(process.env.REACT_APP_ALGOLIA_COURSES_INDEX) : 'wp_posts_course',
    REACT_APP_ALGOLIA_PRESS_INDEX: process.env.REACT_APP_ALGOLIA_PRESS_INDEX ? String(process.env.REACT_APP_ALGOLIA_PRESS_INDEX) : 'wp_posts_press-releases',
    REACT_APP_ALGOLIA_BLOGS_INDEX: process.env.REACT_APP_ALGOLIA_BLOGS_INDEX ? String(process.env.REACT_APP_ALGOLIA_BLOGS_INDEX) : 'wp_posts_type-blogs',
    REACT_APP_ALGOLIA_APP_ID: process.env.REACT_APP_ALGOLIA_APP_ID ? String(process.env.REACT_APP_ALGOLIA_APP_ID) : 'UHZV4N9D6J',
    REACT_APP_ALGOLIA_API_KEY: process.env.REACT_APP_ALGOLIA_API_KEY ? String(process.env.REACT_APP_ALGOLIA_API_KEY) : '9ac710e723a0a036539b77fe5c0d7f94',
  };
};

// Throwing an Error if any field was undefined we don't 
// want our app to run if it can't connect to DB and ensure 
// that these fields are accessible. If all is good return
// it as Config which just removes the undefined from our type 
// definition.

const getSanitzedConfig = (config: ENV): Config => {
  for (const [key, value] of Object.entries(config)) {
    if (value === undefined) {
      throw new Error(`Missing key ${key} in config.env`);
    }
  }
  return config as Config;
};

const config = getConfig();

const sanitizedConfig = getSanitzedConfig(config);

export default sanitizedConfig;

